import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from './routes/privateRoutes';
import PublicRoute from './routes/publicRoutes';
import Login from './pages/auth/login';
import Dashboard from './pages/dashboard';
import Users from './pages/users/users';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Router>
        <Routes>
          <Route path='/' element={<PublicRoute element={Login} />} />
          <Route path='/dashboard' element={<PrivateRoute element={Dashboard} />} />
          <Route path='/users' element={<PrivateRoute element={Users} />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
